/** vendor */
import React from 'react'

/** lib */
import { formatRecipe_SEO_JSON } from '../../utils/recipeSchema'

/** components */
import RecipeStep from './RecipeStep'
import RecipeDetailItem from './RecipeDetailItem'

export default function RecipeDetail({ recipe }) {    
    return (
        <div className="w-full flex justify-center">
            <script type="application/ld+json">{JSON.stringify(formatRecipe_SEO_JSON(recipe))}</script>
            <div className="flex flex-col-reverse w-full">
                <div className="w-full md:flex">
                    <div className="md:w-1/3">
                        <RecipeDetailItem recipe={recipe?.current_recipe ?? recipe} />
                    </div>
                    <div className="md:pl-4 md:pt-2 md:overflow-auto">
                        {
                            // steps for a vendor recipe
                            recipe?.current_recipe?.recipe_steps && 
                                recipe?.current_recipe?.recipe_steps
                                    .sort((a, b) => a.step_order > b.step_order ? 1 : -1)
                                    .map((s) => {
                                        return <RecipeStep 
                                                    step={s} 
                                                    key={s.recipe_step_id} 
                                                    ingredientList={recipe.current_recipe.recipe_ingredients}
                                                />
                                    }    
                                )
                        }

                        {
                            // steps for a user create recipe
                            recipe?.steps && 
                                recipe?.steps
                                    .sort((a, b) => a.step_order > b.step_order ? 1 : -1)
                                    .map((s, i) => 
                                        <RecipeStep 
                                            step={{...s, step_order: i+1}} 
                                            key={s?.recipe_step_id ?? s?.id} 
                                            ingredientList={recipe?.current_recipe?.recipe_ingredients ?? recipe?.ingredients}
                                        />
                                )
                        }
                    </div>
                </div>
            </div>
        </div>  
    )
}